const TWITCH_CLIENT_ID = "jy8ryvk79ccmco22x9m7ggo6ace7bl";
const TWITCH_REDIRECT_URI = import.meta.env.PROD ? import.meta.env.VITE_TWITCH_OAUTH_REDIRECT_URI : "http://localhost:3000/oauth/twitch";

const SignIn = () => {
  return (
    <>
      <div className="w-1/3 m-auto bg-slate-800/90 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 shadow-2xl">
        {/* Logo section */}
        <div className="text-center mb-8">
          <p className="text-slate-400 text-sm">Sign in to your streamer dashboard</p>
        </div>

        {/* Social sign-in buttons */}
        <div className="space-y-3 mb-6">
          <a href={`https://id.twitch.tv/oauth2/authorize?client_id=${TWITCH_CLIENT_ID}&redirect_uri=${TWITCH_REDIRECT_URI}&response_type=code&scope=channel:manage:redemptions`} className="w-full relative flex items-center justify-center gap-3 bg-purple-600/20 hover:bg-purple-600/30 border border-purple-500/30 hover:border-purple-400 rounded-xl px-4 py-3 text-white font-medium transition-all duration-200 hover:transform hover:-translate-y-0.5 group overflow-hidden cursor-pointer">
            <span className="text-xl">🎮</span>
            <span>Continue with Twitch</span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
          </a>
        </div>
      </div>
    </>
  );
};

export default SignIn;